import { useTranslation } from "react-i18next";

import FormFieldSelect, { type FormFieldSelectProps } from "@/components/Form/FormFieldSelect";

export interface LocaleSelectorProps extends Omit<FormFieldSelectProps, "data"> {}
export const LocaleSelector = (props: LocaleSelectorProps) => {
  const { t, i18n } = useTranslation();
  const availableLocales: Record<"value" | "label", string>[] = Object.keys(i18n.services.resourceStore.data).map(
    (locale) => ({
      value: locale,
      label: t(`locale.${locale}` as unknown as TemplateStringsArray),
    }),
  );

  return <FormFieldSelect searchable={false} data={availableLocales} {...props} />;
};

export default LocaleSelector;
